







































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponentModalBackofficeEditarEquipamento extends Vue {
  equipamentoLock: boolean = false
  inputSearch: string = ''
  loading: any = {
    searchProcedimento: false,
    listText: 'Equipamento não encontrado.',
  }

  $refs: {
    getInputSearch: HTMLInputElement
  }

  get backofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  get showModalEquipamento() {
    return this.backofficeGlobalStore.modal.editarEquipamento
  }

  get getEquipamentos() {
    return this.backofficeGlobalStore.solicitacaoAlterada.equipamentos
  }

  get getEquipamentosApi() {
    return this.backofficeGlobalStore.equipamentoGruposApi
  }

  @Watch('showModalEquipamento')
  onChangeGetShowModalEquipamento(value) {
    setTimeout(() => {
      if (value) {
        this.$refs.getInputSearch.focus()
      } else {
        this.$refs.getInputSearch.blur()
      }
    }, 100)
  }

  toggleBodyOverflow(isOpen: Boolean) {
    const html = document.querySelector('body')
    const noOverflowClass = 'modal-is-open'

    if (html !== null) {
      html.classList.remove(noOverflowClass)
      if (isOpen) {
        html.classList.toggle(noOverflowClass)
      }
    }
  }

  async addEquipment(id: string) {
    this.backofficeGlobalStore.addEquipamentoSolicitacaoAlterada(id)
  }

  async removeEquipment(id: string) {
    this.backofficeGlobalStore.removeEquipamentoSolicitacaoAlterada(id)
  }

  closeModal() {
    this.getInputSearch = ''
    this.backofficeGlobalStore.clearEquipamentoGruposApi()
    this.backofficeGlobalStore.setModal({ name: 'editarEquipamento', value: false })
  }

  debounce = _.debounce(input => this.backofficeGlobalStore.getAlterarSolicitacaoEquipamentoGruposApiSearch(input), 600)

  search() {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }
}

